export const reportsFormatter = (reports) => reports.map((r) => ({
  ...r,
  requestData: JSON.parse(r.requestData),
}));

export default reportsFormatter;
